import { BASE_ENDPOINT } from "../../endpoint";

export const retrieveOtherMFISavingsAccountService = async (
	TOKEN: any,
	accountNumber: string,
	institutionId: string,
	signal?: any
) => {
	try {
		if (!institutionId.trim()) return;
		const response = await fetch(
			`${BASE_ENDPOINT}/user/savingsaccount/${institutionId}/accountnumber/${accountNumber}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${TOKEN}`,
					"Content-Type": "application/json",
				},
				signal: signal,
			}
		);
		const res = await response.json();
		if (!response.ok) {
			console.error("Error:", res);
			throw new Error(res.message);
		}
		return res.data;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
